<script lang="ts" setup>
	import BaseModal from '@/components/modals/BaseModal.vue';
	import {removeOrderLinesForDeliveryDate} from 'dummen-shared';
	import {useI18n} from 'vue-i18n';

	const {t} = useI18n();

	const props = defineProps<{
		week: number;
		year: number;
	}>();

	const emits = defineEmits(['close']);

	const cancel = () => {
		emits('close');
	};

	const confirm = () => {
		removeOrderLinesForDeliveryDate({week: props.week, year: props.year});
		emits('close');
	};
</script>

<template>
	<base-modal cancel-button-text=""
	            confirm-button-class="button--orange"
	            confirm-button-text="Delete"
	            @cancel="cancel"
	            @confirm="confirm">
		<template v-slot:title>
			{{ t('shoppingcart.modal.deleteWeek.suffix.title') }}
			{{ week }}
		</template>

		<p>
			{{ t('shoppingcart.modal.deleteWeek.prefix.text') }}
			<strong style="text-transform: lowercase;">
				{{ t('shoppingcart.generic.week.text') }}
				{{ week }}</strong>.<br />
			{{ t('shoppingcart.modal.deleteWeek.suffix.text') }}
		</p>
	</base-modal>
</template>
